import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '@ajaibid/utils';

const IconChevronUp = ({ color, size, className, onClick, height, width }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 448 512"
    height={height || '1em'}
    width={width || '1em'}
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    fontSize={size}
    className={className}
    onClick={onClick}
  >
    <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z" />
  </svg>
);

IconChevronUp.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

IconChevronUp.defaultProps = {
  className: '',
  color: '#333333',
  height: '1em',
  width: '#333333',
  size: 13,
  onClick: noop,
};

export default IconChevronUp;
